import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root',
})
export class LoaderService {
	public isLoading: boolean;

	setLoadingStart() {
		this.isLoading = true;
	}

	setLoadingComplete() {
		this.isLoading = false;
	}
}